import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_ORGANIZATION_STOCK_SUMMARY_PATH,
  GetOrganizationStockSummaryErrorDto,
  GetOrganizationStockSummarySuccessDto,
} from '@/api/rest/resources/types/stocks';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

export type { StockData, StocksData, StocksSummary } from '@/api/rest/resources/types/stocks';

type SuccessDto = GetOrganizationStockSummarySuccessDto;
type ErrorDto = GetOrganizationStockSummaryErrorDto;

export const useStocksSummary = () => {
  const organizationId = useOrganizationId();

  const pathParams = { organization_id: organizationId };

  const queryFn = () => {
    return getRequest<SuccessDto>(GET_ORGANIZATION_STOCK_SUMMARY_PATH, pathParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['organization', organizationId, 'stock-summary'],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
